var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.videoShown)?_c('vue-plyr',[_c('video',{staticStyle:{"max-width":"100%","height":"auto","max-height":"500px"},style:(_vm.makeStyle),attrs:{"controls":"","autoplay":"","loop":"","data-poster":_vm.thumbUrl}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }